// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.aggregate-error.constructor');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/es.aggregate-error.js
// module id = 279
// module chunks = 0 1